import { render, staticRenderFns } from "./CurrentStock.vue?vue&type=template&id=6dcb0fa2&scoped=true"
import script from "./CurrentStock.vue?vue&type=script&lang=js"
export * from "./CurrentStock.vue?vue&type=script&lang=js"
import style0 from "./CurrentStock.vue?vue&type=style&index=0&id=6dcb0fa2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb0fa2",
  null
  
)

export default component.exports